export default function MintPage() {
  return (
    <div className="min-h-screen pt-24 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-8">Mint Portal NFT</h1>
        <p className="text-gray-300">Minting coming soon...</p>
      </div>
    </div>
  );
}
